var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.isPc ? 'index-container' : 'mobile-index-container'},[_c('div',{staticClass:"index-bg"}),_c('div',{staticClass:"app-icon"}),_c('div',{staticClass:"app-title"},[_vm._v("指尖抓娃娃")]),(_vm.curTab.type == 0)?_c('office-home-page'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }